import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { SessionTimeoutService } from '../services/session-timeout.service';

/**
 * Treats a 401 on an authenticated request as an expired session.
 *
 * Only requests that carried a token count: a 401 on a request sent without
 * one points at an API missing from the Auth0 interceptor's allowedList, and
 * redirecting to login for that would loop forever. Register after
 * AuthHttpInterceptor so the Authorization header is already attached.
 */
@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {
  private readonly sessionTimeout = inject(SessionTimeoutService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && req.headers.has('Authorization')) {
          this.sessionTimeout.handleSessionExpired();
        }
        return throwError(() => error);
      })
    );
  }
}
